import { render } from "./CharacterModal.vue?vue&type=template&id=0c713324&scoped=true"
import script from "./CharacterModal.vue?vue&type=script&lang=js"
export * from "./CharacterModal.vue?vue&type=script&lang=js"

import "./CharacterModal.vue?vue&type=style&index=0&id=0c713324&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c713324"]])

export default __exports__